const colors = {
  marketingGreen: 'rgba(4, 155, 74, 1)',
  marketingGreenHover: 'rgba(4, 140, 67, 1)',
  logoAppNameBlack: 'rgba(22, 22, 22, 1)',
  hoverLangOption: 'rgba(243, 243, 243, 1)',
};

const globals = {
  headerHeight: 70,
  headerAndNavHeight: 126,
  mobileSearchHeight: 56,
  mobileHeaderHeight: 74,
  progressBarHeight: 2,
  navHeight: 50,
};

// this is partially based on https://github.com/circleci/compass/blob/main/src/theme/index.ts
export const outerTheme = {
  colors,
  globals,
};
